import { capitalize, resizeVtexImage } from '@core/utils';
import { getItemCategory, getItemCategory2 } from '../utils'
import type { InitialConfig, ItemsResponse } from '@src/types'
import type { 
  HeadlessValuePDPContext,
  HeadlessItemsPDPContext,
  HeadlessBrandPDPContext,
  HeadlessLineItemsPDPContext,
} from "../types";

export const HeadlessPdpZone = {
  items: (context: HeadlessItemsPDPContext): ItemsResponse[] | null => {
    if (context?.items) return context.items

    if (context?.products) {
      return context.products.map((item) => {
        const listPrice = item?.items[0].sellers?.[0].commertialOffer.ListPrice
        const price = item?.items[0].sellers?.[0].commertialOffer.Price

        return {
          quantity: 1,
          index: item?.index ?? null,
          item_brand: capitalize(item.brand) ?? null,
          item_name: item.productName ?? null,
          price: price ?? null,
          item_shipping_tier: null,
          discount: Number(listPrice) - Number(price),
          item_variant: item.items[0]?.name?.split(" - ")[0] ?? null,
          item_variant2: item.items[0]?.name?.split(" - ")[1] ?? null,
          item_ref: item.productReference ?? null, // sem ref no retorno do IS na multi-lib produtos PDC
          item_category: getItemCategory(item),
          item_category2: getItemCategory2(item) ?? null,
          item_id: item?.productId ?? null,
          item_sku: item.items?.[0].itemId ?? null,
          item_url: item.link ?? null, // sem link/url no retorno do IS na multi-lib produtos PDC
          image_url: resizeVtexImage(item?.items?.[0].images?.[0].imageUrl) ?? null,
          seller_id: item.items?.[0]?.sellers?.[0].sellerId ?? null,
          item_list_name: item.item_list_name ?? null,
        }
      })
    }

    return null;
  },

  value: (context: HeadlessValuePDPContext): number | null => {
    if (context?.value) return context.value

    if (context?.products) {
      return context.products
        .map((item) => item?.items[0].sellers?.[0].commertialOffer.Price)
        .filter((price): price is number => price !== undefined)
        .reduce((sum, price) => sum + price, 0)
    }

    return null
  },

  line_items: (context: HeadlessLineItemsPDPContext): string | null => {
    if (context?.line_items) return context.line_items;

    if (context?.products) {
      return context.products
        .map((item) => item.productId)
        .filter((id): id is string => Boolean(id))
        .join()
    }

    return null;
  },

  brand: (context: HeadlessBrandPDPContext, config: InitialConfig): string | null => {
    if (config?.brand) return config.brand
    if (context?.brand) return context.brand
    if (context?.products) {
      return context.products.map((p) => p.brand).join().trim()
    }

    return null
  },
}